import React from "react";
import AppTheme from "../../../../service/app_config/AppTheme";
import { IconNormal } from "../../../../widget/common/ui/Icon";
import { BranchTeamContextImport } from "../../../../provider/branch/branch_team/BranchTeamContextProvider";

const BranchTeamActions = () => {
  const { showSearch, updateShowSearch } = BranchTeamContextImport();

  return (
    <>
      {!showSearch && (
        <IconNormal
          name="magnify"
          color={AppTheme.themeFont}
          handleClick={() => updateShowSearch()}
        />
      )}
    </>
  );
};

export default BranchTeamActions;
